// The tabs of Settings › Task types. Split out of TaskTypes.tsx (performance-closure, plan §10.2) so the
// route validates `?tab=` without loading the editor screen (rich text, fields, playbooks) up front.
export const TASK_TYPE_TABS = [
  'general',
  'fields',
  'lifecycle',
  'sla',
  'assignment',
  'layout',
  'actions',
  'translations',
] as const;
export type TaskTypeTab = (typeof TASK_TYPE_TABS)[number];
